window.Wishlist = {
  key: 'shopify_wishlist',

  get() {
    return JSON.parse(localStorage.getItem(this.key)) || [];
  },

  save(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
  },

  toggle(handle) {
    let items = this.get();
    items.includes(handle)
      ? items = items.filter(h => h !== handle)
      : items.push(handle);
    this.save(items);
    return items;
  },

  has(handle) {
    return this.get().includes(handle);
  }
};

/* ✅ GLOBAL FUNCTION */
function updateWishlistCount() {
  const count = Wishlist.get().length;

  document.querySelectorAll('.wishlist-count').forEach(el => {
    el.innerText = count;
    el.toggleAttribute('hidden', count === 0);
  });
}

/* ✅ CLICK HANDLER */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  e.preventDefault();

  const handle = btn.dataset.handle;
  Wishlist.toggle(handle);
  btn.classList.toggle('active', Wishlist.has(handle));

  updateWishlistCount();
});

/* ✅ ON PAGE LOAD */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    btn.classList.toggle('active', Wishlist.has(btn.dataset.handle));
  });

  updateWishlistCount();
});
